module.exports = __webpack_public_path__ + "static/img/logo_pic.953841a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_pic.png
// module id = k+tn
// module chunks = 94